/* import __COLOCATED_TEMPLATE__ from './format-cell.hbs'; */
import templateOnlyComponent from '@ember/component/template-only';
import type { CellBaseCellSignature } from './base-cell';

interface CellFormatCellSignature {
  Args: CellBaseCellSignature['Args'];
}

const CellFormatCellComponent = templateOnlyComponent<CellFormatCellSignature>();

export default CellFormatCellComponent;

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'Cell::FormatCell': typeof CellFormatCellComponent;
    'cell/format-cell': typeof CellFormatCellComponent;
  }
}
